import React from "react";
import { FormName } from "redux-form/immutable";

export default (Component) => (props) => <FormName>{({ form }) => <Component form={form} {...props} />}</FormName>;
